module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 12
// module chunks = 0 1 2 3 4 5 6 7 10 11